// @codekit-prepend '../../../node_modules/jquery/dist/jquery.min.js';
// @codekit-prepend '../../../node_modules/foundation-sites/dist/js/plugins/foundation.core.min.js';
// @codekit-prepend '../../../node_modules/foundation-sites/dist/js/plugins/foundation.util.keyboard.min.js';
// @codekit-prepend '../../../node_modules/foundation-sites/dist/js/plugins/foundation.util.mediaQuery.min.js';
// @codekit-prepend '../../../node_modules/foundation-sites/dist/js/plugins/foundation.util.triggers.min.js';
// @codekit-prepend '../../../node_modules/foundation-sites/dist/js/plugins/foundation.util.motion.min.js';
// @codekit-prepend '../../../node_modules/foundation-sites/dist/js/plugins/foundation.util.touch.min.js';
// @codekit-prepend '../../../node_modules/foundation-sites/dist/js/plugins/foundation.offcanvas.min.js';
// @codekit-prepend '../../../node_modules/foundation-sites/dist/js/plugins/foundation.reveal.min.js';
$(document).foundation();
